import { Component, OnInit } from "@angular/core";
import { HomeService } from "../home/home.services";
import { DataDirectoryService } from "../data-directory/data-directory.service";
import { ToastMessageService } from "src/app/toastr.service";
import { FormGroup, FormBuilder } from "@angular/forms";
import * as _ from "underscore";

@Component({
  selector: "app-commercial-intelligence",
  templateUrl: "./commercial-intelligence.component.html",
  styleUrls: ["./commercial-intelligence.component.scss"],
})
export class CommercialIntelligenceComponent implements OnInit {
  allMoleculeData;
  MoleculeData1;
  searchValue = "";
  brandname = "";
  tempData: any = {};
  showedit = false;
  subMolecule = false;
  sliceEnd = 5;
  submolecules: any[];
  selectedSubMolecule: any;
  Molecule = false;
  needRefresh: boolean;
  apiCost: any;
  DragData: any = {};
  nda_number: any;
  email: any;

  constructor(
    private toastService: ToastMessageService,
    private homeservice: HomeService,
    private formBuilder: FormBuilder,
    private directoryservice: DataDirectoryService
  ) {
    this.submolecules = [];
  }

  ngOnInit(): void {
    this.email = localStorage.getItem("email");
  }

  arrayToDropdown(InputArray) {
    let DropDownArray = [];
    InputArray.forEach((DropdownValues) => {
      let dropDownObj = {
        name: `${DropdownValues.brand_name},${DropdownValues.nda_number},${DropdownValues.dosage_forms}`,
        code: DropdownValues // store the full object for later use
      };
      DropDownArray.push(dropDownObj);
    });
    return DropDownArray;
  }

  searchMolecule1() {
    this.submolecules = [];
    let brand_name = this.brandname;
    console.log(brand_name);
    this.homeservice.GetNda(brand_name).subscribe((response) => {
      this.MoleculeData1 = response["data"].nda_numbers;
      if (this.MoleculeData1 != null) {
        let dropdownvalues = this.arrayToDropdown(this.MoleculeData1);
        this.submolecules = dropdownvalues;
        const Array = this.submolecules[0].name.split(",")[1];
        this.nda_number = Array;
        this.subMolecule = true;
        this.Molecule = false;
        this.DragData = {};
      } else {
        this.selectedSubMolecule = {};
        this.subMolecule = false;
        this.Molecule = false;
        this.DragData = {};
      }
    });
  }
  getData1() {
    if (this.selectedSubMolecule !== undefined) {
      let data = {
        nda_number: this.selectedSubMolecule["name"].split(",")[1],
        brand_name: this.selectedSubMolecule["name"].split(",")[0],
        user_email: this.email,
      };

      this.homeservice.getCommercialData(data).subscribe((response) => {
        this.allMoleculeData = response["data"].commercial_intilegence;
        if (response["status"] == "200") {
          this.Molecule = true;
          this.toastService.success("Data Fetched Successfully");
          return;
        } else {
          this.toastService.error("Data Not Found !");
          return;
        }
      });
    }
  }

  saveMolecule(datalist) {
    this.showedit = !this.showedit;
    let data = {
      brand_name: this.selectedSubMolecule["name"].split(",")[0],
      nda_number: this.selectedSubMolecule["name"].split(",")[1],
      data_list: [datalist],
    };
    localStorage.setItem("molecules", JSON.stringify(data));
    this.homeservice.UpdateCommercialData(data).subscribe(
      (response) => {
        this.allMoleculeData =
          response["data"].commercial_intilegence["Approved ANDA filers"].value;
        if (response["status"] == "200") {
          this.toastService.success("Data updated successfully");
          this.getData1();
          return;
        } else {
          this.toastService.error("Data not saved !");
          this.getData1();
          return;
        }
      },
      (error) => {
        this.toastService.error(
          typeof error === "string" ? error : error.message
        );
        this.getData1();
      }
    );
  }

  saveAllMolecule(aNDa, fNDa, tNDa, eNDa) {
    let myArray = [];
    var Approved = aNDa;
    var Tentatively = tNDa;
    var Filed = fNDa;
    var Expected = eNDa;
    let myArr = [];
    for (let i = 0; i < Approved.length; i++) {
      myArr.push(Approved[i]);
    }
    for (let i = 0; i < Tentatively.length; i++) {
      myArr.push(Tentatively[i]);
    }
    for (let i = 0; i < Filed.length; i++) {
      myArr.push(Filed[i]);
    }
    for (let i = 0; i < Expected.length; i++) {
      myArr.push(Expected[i]);
    }

    // if(Approved){
    //   myArray.push(...Approved[0]);
    // }
    // if(Tentatively){
    //   myArray.push(...Tentatively[0]);
    // }
    // if(Filed){
    //   myArray.push(Filed);
    // }
    // if(Expected){
    //   myArray.push(...Expected[0]);
    // }
    this.showedit = !this.showedit;
    let data = {
      brand_name: this.selectedSubMolecule["name"].split(",")[0],
      nda_number: this.selectedSubMolecule["name"].split(",")[1],
      data_list: myArr,
    };
    localStorage.setItem("molecules", JSON.stringify(data));
    this.homeservice.UpdateCommercialData(data).subscribe(
      (response) => {
        if (response["status"] == "200") {
          this.toastService.success("Data updated successfully");
          this.getData1();
          return;
        } else {
          this.toastService.error("Data not saved !");
          this.getData1();
          return;
        }
      },
      (error) => {
        this.toastService.error(
          typeof error === "string" ? error : error.message
        );
        this.getData1();
      }
    );
  }

  editbtn() {
    this.showedit = !this.showedit;
    if (this.showedit === true) {
      this.sliceEnd = 1000;
    } else {
      this.sliceEnd = 5;
    }
  }

  editdata(event, arr, keys, trows, rd, Obj, index, n10) {
    if (Obj !== undefined) {
      if (this.tempData[keys] && Obj.value) {
        this.tempData[keys].map((res, j) => {
          Obj.value.map((resp, j1) => {
            if (j === index && j === j1) {
              let objkey = Object.keys(Obj.value[0]);
              let uniquekey = objkey[n10];
              resp[uniquekey] = event.target.value;
            }
          });
        });
      }
    }
    if (Obj === "lItems") {
      if (Array.isArray(this.tempData[keys])) {
        this.tempData[keys].map((respp, k) => {
          if (arr) {
            arr.map((resps, p) => {
              if (p === rd) {
                if (resps === trows) {
                  arr[rd] = event.target.value;
                }
              }
            });
          } else {
          }
        });
      }
    } else if (Obj === undefined) {
      this.tempData[keys] = event.target.value;
    }
  }

  clearFilter() {
    this.submolecules = [];
    this.selectedSubMolecule = {};
    this.Molecule = false;
    this.brandname = "";
    this.subMolecule = false;
  }
}
